export default "/assets/images/pc-carbon.png?eaf94ea3ecacd52d207e0cb9f2ba6625";